const faqContentPro = [
  {
    title: 'What is Autzu PRO?',
    info: [
      {
        pretext:
          'Autzu PRO is our tier of premium vehicles, starting at $6 per hour. Autzu PRO vehicles allow you to accept various ridesharing trip requests, including:'
      },
      {
        text: {
          plaintext:
            'Standard (UberX, UberPool, Lyft Standard, Lyft Shared)'
        }
      },
      {
        text: { plaintext: 'Premium (Uber Comfort, Lyft Lux)' }
      },
      {
        text: { plaintext: 'Food Delivery (Uber Eats)' }
      }
    ]
  },
  {
    title: 'What kind of vehicles are available on Autzu PRO?',
    info: [
      {
        pretext:
          'Autzu PRO vehicles include the BMW 3 Series, BMW X1 and BMW X2.'
      }
    ]
  },
  {
    title: 'Who can drive on Autzu PRO?',
    info: [
      {
        link: {
          leadingText:
            'You can drive Autzu PRO if you are 21 years old and have a full valid driver’s license.',
          title: 'Download the Autzu app',
          href: 'https://www.autzu.com/signup',
          trailingText: 'and sign up to drive today!'
        }
      }
    ]
  }
];

export default faqContentPro;



// WEBPACK FOOTER //
// ./src/components/Static/TorontoFleets/AutzuPro/FaqContentPro.js